export default __webpack_public_path__ + "static/media/ephemeralart.13eb30ac.webp";